module.exports = __webpack_public_path__ + "img/wdr4-logo.54863249.svg";